import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/office365.png'


const _hoisted_1 = {
  key: 0,
  class: "login__error"
}
const _hoisted_2 = { class: "login__error-title" }
const _hoisted_3 = { class: "login__error-message" }
const _hoisted_4 = { class: "login__form" }
const _hoisted_5 = { class: "login__step-container email" }
const _hoisted_6 = { class: "login__disclaimer" }
const _hoisted_7 = { class: "login__button-container" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "login__password-label-container" }
const _hoisted_10 = {
  class: "login__password-label",
  for: "password"
}
const _hoisted_11 = { class: "login__button-container signin" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "login__office-sign-in-container" }
const _hoisted_14 = { class: "office-label office365-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconErrorLoginFailed = _resolveComponent("iconErrorLoginFailed")!
  const _component_hadrianLoader = _resolveComponent("hadrianLoader")!
  const _component_inputGroup = _resolveComponent("inputGroup")!
  const _component_hadrianTooltip = _resolveComponent("hadrianTooltip")!
  const _component_hadrianRouterLink = _resolveComponent("hadrianRouterLink")!
  const _component_hadrianCheckbox = _resolveComponent("hadrianCheckbox")!
  const _component_authenticationPage = _resolveComponent("authenticationPage")!

  return (_openBlock(), _createBlock(_component_authenticationPage, {
    showLinks: "",
    showHeader: !(_ctx.userIsDisabled && _ctx.currentStep === _ctx.LoginSteps.Disabled)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["login__container", { 'login__container--without-header': _ctx.userIsDisabled && _ctx.currentStep === _ctx.LoginSteps.Disabled }])
      }, [
        (_ctx.userIsDisabled && _ctx.currentStep === _ctx.LoginSteps.Disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_iconErrorLoginFailed),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('login.errors.failedTitle')), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('login.errors.failedMessage')), 1)
              ]),
              _createElementVNode("button", {
                class: "btn btn-round btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToEmail && _ctx.backToEmail(...args)))
              }, _toDisplayString(_ctx.$t('login.backToLogin')), 1)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_component_hadrianLoader, {
            isLoading: _ctx.pendingLogin,
            semiTransparent: true
          }, null, 8, ["isLoading"]),
          _createVNode(_component_hadrianLoader, {
            isLoading: _ctx.pendingHadrianLogin,
            message: _ctx.$t('login.pendingHadrianLogin')
          }, null, 8, ["isLoading", "message"]),
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submitLogin()), ["prevent"])),
            class: "login__body",
            autocomplete: "on"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["login__animation-container", {
              transformed: _ctx.currentStep === _ctx.LoginSteps.EmailEntered,
              userdisabled: _ctx.currentStep === _ctx.LoginSteps.Disabled,
            }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('login.disclaimer')), 1),
                _createVNode(_component_inputGroup, {
                  id: "email",
                  label: _ctx.$t('login.emailLabel'),
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                  type: "email",
                  ref: "emailInput",
                  "aria-describedby": "inputFormatterHelp",
                  placeholder: _ctx.$t('login.emailPlaceholder'),
                  autocomplete: "email",
                  trim: ""
                }, null, 8, ["label", "modelValue", "placeholder"]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_hadrianTooltip, {
                    anchor: "right",
                    verticalPosition: "above",
                    enabled: !_ctx.enableSecondStep,
                    tooltipText: _ctx.$t('login.validation.email')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "submit",
                        role: "submit",
                        class: "login__continue-button btn btn-primary btn-round",
                        disabled: _ctx.disableContinue
                      }, _toDisplayString(_ctx.$t('login.continue')), 9, _hoisted_8)
                    ], undefined, true),
                    _: 1
                  }, 8, ["enabled", "tooltipText"])
                ])
              ]),
              _withDirectives(_createElementVNode("div", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitLogin()), ["prevent"])),
                class: _normalizeClass(["login__step-container", {
                'login__step-container--disabled': _ctx.currentStep !== _ctx.LoginSteps.EmailEntered,
              }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button-reset login__back-to-email",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToEmail && _ctx.backToEmail(...args)))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.email), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('login.password')), 1),
                    _createVNode(_component_hadrianRouterLink, {
                      class: "login__forgot-password",
                      url: _ctx.forgotPasswordUrl(),
                      mainLabel: _ctx.$t('login.forgotPassword')
                    }, null, 8, ["url", "mainLabel"])
                  ]),
                  _createVNode(_component_inputGroup, {
                    id: "password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                    type: "password",
                    name: "password",
                    autocomplete: "current-password",
                    placeholder: "",
                    "aria-describedby": "inputFormatterHelp",
                    ref: "passwordInput"
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createVNode(_component_hadrianCheckbox, {
                    class: "login__keep-logged-in",
                    modelValue: _ctx.keepMeLoggedIn,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.keepMeLoggedIn) = $event)),
                    noMargins: true,
                    label: _ctx.$t('login.keep')
                  }, null, 8, ["modelValue", "label"]), [
                    [_vShow, _ctx.currentStep === _ctx.LoginSteps.EmailEntered]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_hadrianTooltip, {
                    verticalPosition: "above",
                    anchor: "right",
                    tooltipText: _ctx.invalidPasswordMessage,
                    enabled: !_ctx.allowLogin
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.disableLogin,
                        role: "submit",
                        class: "btn btn-primary btn-round"
                      }, _toDisplayString(_ctx.$t('login.signin')), 9, _hoisted_12)
                    ], undefined, true),
                    _: 1
                  }, 8, ["tooltipText", "enabled"])
                ])
              ], 34), [
                [_vShow, !_ctx.hadrianUserLogin]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["login__step-container", {
                'login__step-container--disabled': _ctx.currentStep !== _ctx.LoginSteps.EmailEntered,
              }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button-reset login__back-to-email",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.backToEmail && _ctx.backToEmail(...args)))
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.email), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    ref: "office365Button",
                    class: "button-reset office-sign-in",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.office365SignIn && _ctx.office365SignIn(...args)))
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "office365"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('login.office365')), 1)
                  ], 512)
                ])
              ], 2), [
                [_vShow, _ctx.hadrianUserLogin]
              ])
            ], 2)
          ], 32)
        ], 512), [
          [_vShow, _ctx.currentStep !== _ctx.LoginSteps.Disabled]
        ])
      ], 2)
    ], undefined, true),
    _: 1
  }, 8, ["showHeader"]))
}